export const roundToDecimalPlaces = (num: number, decimalPlaces = 0) => {
  try {
    const localeString = num.toLocaleString("en-US", {
      minimumFractionDigits: decimalPlaces,
      maximumFractionDigits: decimalPlaces,
      style: "decimal",
    });

    if (localeString === "-0") {
      return "0";
    }

    return localeString;
  } catch {
    return "0";
  }
};

export const formatToMillions = (num: number): string => {
  try {
    // Convert to millions
    const millions = num / 1000000;

    // Format with 2 decimal places
    const formatted = millions.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      style: "decimal",
    });

    // Add the M suffix
    return `$${formatted}M`;
  } catch {
    return "";
  }
};
